<template>

    <main class="main" style="margin-top: 150px">
        <div class="cloudsTop"></div>
        <div class="container mt-20 min-h-700px">
            <div class="row mt-10 justify-content-center match-height">

                <div class="col-md-12 mb-4" v-if="loading">
                    <paragraph-shimmer :lines="3" :random-size="true"/>
                </div>
                <div class="col-md-12 mb-4" v-if="!loading && !events.length">
                    <div style="width: 320px;margin: auto">
                        <client-only>
                            <Vue3Lottie
                                    animationLink="https://assets5.lottiefiles.com/packages/lf20_rc6CDU.json"
                            />
                        </client-only>
                    </div>
                    <h4 class="mt-10 text-center">{{$t('no_data')}}</h4>
                </div>
                <div class="col-md-4 mt-3" v-for="(_events,key) in events" :key="key">
                    <div class="card cursor-pointer" @click="goToShowNews(_events._id)">
                        <div class="card-body p-0">
                            <img :src="$helpers.getImagePath(store.getters['moduleCommon/getConfigImagePath']+_events.image)"
                                 class="img-thumbnail h-300px w-100" alt="">
                        </div>
                        <div class="card-body pb-1" style="overflow:hidden;">
                            <a href="javascript:void(0)" class="float-start text-danger" @click="goToShowNews(_events._id)">
                                <b>{{$t('show_details')}}</b>
                            </a>
                            <div>
                                <h5 class="mt-2" v-if="i18n.locale.value == 'ar'">{{_events.title.ar}}</h5>
                                <h5 class="mt-2" v-if="i18n.locale.value == 'en'">{{_events.title.en}}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script lang="ts">
  import { defineComponent, reactive, toRefs, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';

  export default defineComponent({
    name: 'News',
    setup() {
      const store = useStore();
      const i18n = useI18n();
      const router = useRouter();

      const state = reactive({
        loading: false,
        events: [],
      });

      onMounted(() => {
        getAllNews();
      });

      const getAllNews = () => {
        state.loading = true;
        store.dispatch('moduleCommon/getEvents').then((response) => {
          state.loading = false;
          state.events = response.data.docs;
        }).catch(() => {
          state.loading = false;
        });
      };

      const goToNews = () => {
        router.push({ name: 'events' });
      };
      const goToShowNews = (id) => {
        router.push({ name: 'show_events', params: { id: id } });
      };

      return {
        ...toRefs(state),
        store,
        i18n,
        goToNews,
        goToShowNews,
      };
    },
  });
</script>
